import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React from "react";
import { useNavigate } from "react-router-dom";
import AddEditConcernForm from "../../../components/section/catalog/AddEditConcernForm";

const AddProductConcern = () => {
  const navigate = useNavigate();

  return (
    <section className="container_xxl bg-[#eceff1] px-4">
      <div className="flex items-center space-x-4 headingBorder__b sticky top-0 z-10">
        <div>
          <IconButton onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </IconButton>
        </div>
        <div>
          <h1 className="heading">Add Product Concern</h1>
        </div>
      </div>

      <AddEditConcernForm isEdit={false} />
    </section>
  );
};

export default AddProductConcern;
